import * as actionTypes from '../actions/ActionTypes';

import * as api from '../../shared/services/api/apiAuth';

import { showCompanies } from '../actions/SignupActions';

import { all, put, takeEvery } from 'redux-saga/effects';

import { startLoading, stopLoading } from '../actions/CommonActions';
import { checkOffline } from '../../shared/services/Utility';

function* signupRequest({ type, signUpBody, callback }) {
  try {
    yield put(startLoading());
    const data = yield api.signupRequest(signUpBody);
    if (data.status === 1) {
      callback('Sign Up successful', 'success');
    } else {
      // alert(data.message);
      callback(data.message, 'info');
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      callback('You are offline.', 'error');
    } else {
      callback('Something went wrong.', 'error');
    }
  }
}

function* fetchCompanies(action) {
  try {
    const data = yield api.fetchCompanies();
    if (data.status === 1) {
      yield put(showCompanies(data.companyDetails));
    }
  } catch (e) {
    action.callback('Failed to fetch companies');
  }
}

function* signUpSaga() {
  yield all([
    takeEvery(actionTypes.SIGNUP_REQUEST, signupRequest),
    takeEvery(actionTypes.FETCH_COMPANIES_REQUEST, fetchCompanies),
  ]);
}

export default signUpSaga;
